import { template } from "@ember/template-compiler";
import { analyticsEnabled, shouldShowBanner } from '../utils/datagrail';
import { service } from '@ember/service';
import { task, timeout } from 'ember-concurrency';
import Component from '@glimmer/component';
/**
 * Initializes DataGrail consent management event callbacks.
 */ export default class DgConsentBanner extends Component {
    @service
    fastboot;
    @service
    session;
    constructor(){
        super(...arguments);
        this.initDatagrail();
        this.pollForConsentBannerTask.perform();
    }
    checkForConsent(preferences1) {
        if (window.mixpanel && !analyticsEnabled(preferences1)) {
            window.mixpanel.reset();
        }
    }
    initDatagrail = ()=>{
        if (typeof window === 'undefined') return;
        window.dgEvent = window.dgEvent || [];
        window.dgEvent.push({
            event: 'preference_callback',
            params: this.checkForConsent
        });
        window.dgEvent.push({
            event: 'initial_preference_callback',
            params: this.checkForConsent
        });
    };
    @task(function*() {
        let shouldShow1 = shouldShowBanner(this.fastboot?.isFastBoot);
        if (!shouldShow1) {
            return;
        }
        const pollIntervalMs1 = 200;
        const maxPollMs1 = 10_000;
        const maxAttempts1 = Math.ceil(maxPollMs1 / pollIntervalMs1);
        for(let attempts1 = 0; attempts1 < maxAttempts1; attempts1++){
            if (typeof window.DG_BANNER_API?.showConsentBanner === 'function') {
                window.DG_BANNER_API.showConsentBanner();
                return;
            }
            yield timeout(pollIntervalMs1);
        }
    }).drop()
    pollForConsentBannerTask;
    static{
        template(`
    {{! intentionally renders nothing; this component exists to initialize DataGrail callbacks }}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
